/* eslint-disable no-debugger */
import { PersonHttpHelper, NO_DATA_MESSAGE } from '@usas/ui-web/utils/HttpHelper';
import { isValidMemberId } from '@usas/ui-web/utils/validation';

import Constants from '@usas/ui-web/utils/Constants';

export const localValidate = (formState) => {
  let errors = {};

  // add validation only
  if (!(formState.personId)) {
    if (formState.memberId.trim().length === 0) {
      errors.memberId = 'Staff Member Id is required'
    } else if (isValidMemberId(formState.memberId.trim()) === false) {
      errors.memberId = 'Staff Member Id must be 14 alphanumeric characters'
    }
  }

  const roleIndex = formState.coachRoleIds.findIndex(x => x === formState.selectedOrgRoleId);
  if (roleIndex !== -1 && formState.coachTypeCode === '') {
    errors.coachTypeCode = 'Must make a selection';
  }

  if (formState.headCoachOrgRoleId === formState.selectedOrgRoleId && formState.secondCoachMemberId === formState.memberId) { 
    errors.memberId = 'Head Coach and Second Coach cannot be the same member';
  }

  if (formState.secondCoachOrgRoleId === formState.selectedOrgRoleId && formState.headCoachMemberId === formState.memberId) { 
    errors.memberId = 'Head Coach and Second Coach cannot be the same member';
  }

  return errors;
};

const serverValidate = async (formState) => {
  let errors = {};

  const memberIdForUrl = formState.memberId ? encodeURIComponent(formState.memberId) : 'NaN';

  let isCoachRole = false;
  if (formState.coachRoleIds) {
    isCoachRole = formState.coachRoleIds.some(x => x === formState.selectedOrgRoleId);
  }

  const url = `/Person/memberId/${memberIdForUrl}/NonAthlete/GoodStanding?isCoachRole=${isCoachRole}`;
  await PersonHttpHelper(url, 'GET')
    .then((objData) => {
      if (!objData) {
        throw new Error(NO_DATA_MESSAGE);
      }
      else {
        if (objData.isInGoodStanding === false || !(objData.personId)) {
          errors.apiError = "This member is not in good standing. Only members in good standing can be added as club staff";
        } else if (objData.orgRoleId === formState.juniorCoachOrgRoleId && formState.selectedOrgRoleId === formState.headCoachOrgRoleId) {
          errors.apiError = "Junior Coach cannot be added as a Head Coach";
        } else if (objData.orgRoleId === formState.provisionalCoachOrgRoleId && formState.selectedOrgRoleId === formState.headCoachOrgRoleId) {
          errors.apiError = "Provisional Coach cannot be added as a Head Coach";
        } else {
          formState.postPersonId = objData.personId;
        }
      }
    })
    .catch((e) => {
      errors.apiError = 'Staff Member Id is not valid'
    });

  return errors;
};


const ClubRegistrationStaffDetailValidation = async (formState) => {
  let errors = localValidate(formState);
  if (!errors || Object.keys(errors).length === 0) {
    errors = await serverValidate(formState);
  }

  return errors ? errors : {};
}

export default ClubRegistrationStaffDetailValidation;